module.exports = __webpack_public_path__ + "static/img/物业-3.3f8acde0.png";